import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {RequestRefundEmailModel} from '../../../../../../models';


@Injectable({ providedIn: 'root' })
export class RequestRefundEmailService extends BaseApiTemplateService<RequestRefundEmailModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'emails/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;

    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'emails/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    this.httpClient = http;
  }

  sendEmailNotification(branchGuid, dtoObject: RequestRefundEmailModel, visa: ApiVisa) {
    let url = this.apiUrl + '/' + branchGuid;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/' + branchGuid;
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }
}
